<script setup lang="ts">
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import Timeline from '@/components/Timeline.vue'
import { Location, Step } from '@/models'
import ConfirmationMessage from '@/steps/ConfirmationMessage.vue'
import ErrorMessage from '@/steps/ErrorMessage.vue'
import Locations from '@/steps/Locations.vue'
import UserData from '@/steps/UserData.vue'
import { useDriveStore } from '@/store/drive'

const store = useDriveStore()

const steps: Array<Step> = [Step.userData, Step.location, Step.confirmation]

const submitUserData = (firstName: string, lastName: string, email: string, phone: string, licensePlate: string) => {
    store.firstName = firstName
    store.lastName = lastName
    store.email = email
    store.phone = phone
    store.licensePlate = licensePlate
    store.retrieveLocations()
}
const submitLocation = (location: Location) => {
    store.location = location
    store.requestInvite()
}
</script>

<template>
    <Timeline
        class="mb-4"
        :steps="steps"
        :current-step="store.step"
    />
    <UserData
        v-if="store.step === Step.userData"
        submit-label="Verder"
        @submit="submitUserData"
    >
        Wil jij gebruik maken van de gratis CUPRA rijtraining en alles te weten komen over jouw CUPRA? Vul je gegevens in zodat VVGN, onze partner
        voor rijtrainingen, je een uitnodiging voor de CUPRA rijtraining kan sturen.

        <!-- <p class="mt-4">&rarr; Tip: de meldcode vind je op je kentekenbewijs. Je kenteken en meldcode worden alleen gebruikt om je te verifiëren.</p> -->
    </UserData>
    <Locations
        v-else-if="store.step === Step.location && store.locations"
        @back="store.$reset()"
        submit-label="Aanvragen"
        @submit="submitLocation"
        :map-options="store.mapOptions"
        :locations="store.locations"
    >
        Waar zou je de rijtraining willen volgen?
        <template #footer>Door op Aanvragen te klikken, worden je gegevens doorgestuurd naar VVGN, onze partner voor rijtrainingen.</template>
    </Locations>
    <ErrorMessage
        v-else-if="store.step === Step.error"
        @retry="store.requestInviteError = undefined"
    >
        {{ store.formattedRequestInviteError }}
    </ErrorMessage>
    <ConfirmationMessage v-else-if="store.step === Step.confirmation"> Je ontvangt binnenkort een uitnodiging. </ConfirmationMessage>
    <LoadingSpinner v-else />
</template>
